import type { Writable, Readable } from "svelte/store";

export function isWritable<T = unknown>(store: any): store is Writable<T> {
  return (
    store &&
    typeof store === "object" &&
    "subscribe" in store &&
    "set" in store &&
    "update" in store &&
    typeof store.subscribe === "function" &&
    typeof store.set === "function" &&
    typeof store.update === "function"
  );
}

export function isReadable(item: any): item is Readable<unknown> {
  return (
    item && typeof item === "object" && "subscribe" in item && typeof item.subscribe === "function"
  );
}
